import { GetStartedView } from '../views';
export default GetStartedView;
